import {mapMutations} from "vuex";

export default {
    name: 'order-product',
    props: {
        item: {
            type: Object,
            default: () => {
            }
        }
    },
    data() {
        return {}
    },
    methods: {
        ...mapMutations({
            decrement: 'order/DECREMENT_BASKET_LIST_COUNT',
        })
    }

}
